"use client";

import { useState } from "react";

const SAME_WIDTH = new Set(["search", "chat"]);

/**
 * How the column beside the rail should move on this render, for SideNav's
 * `data-nav-motion` (the `.nav-slot` rules in app/globals.css). `column` is
 * what has it: "search", "chat", "panel" (the menu panel) or null.
 *
 * Undefined until the column first changes, so nothing animates on page
 * load. "in-place" when search and the chat hand the column straight to each
 * other: they are the same width, so it swaps in one frame instead of one
 * shrinking while the other grows. "resize" for every other change; opening
 * and closing are the same motion played either way.
 *
 * The value is worked out during the render that changes `column`, so it is
 * on the frame in the same commit as the new widths, which is when the
 * browser picks the transition.
 */
export function useNavColumnMotion(column) {
  const [last, setLast] = useState({ column, motion: undefined });
  if (last.column === column) return last.motion;
  const motion =
    SAME_WIDTH.has(last.column) && SAME_WIDTH.has(column) ? "in-place" : "resize";
  setLast({ column, motion });
  return motion;
}
